import Vue from "vue";

import "../plugins/config.js";
import "../plugins/service/index.js";
import "../plugins/languagen/index.js";
import Util from "./Util.controller";
import { ENDPOINTS, ID_LOGIN_SI } from "../plugins/service/Endpoints.js";
import router from "@/plugins/router/index.js";

import _ from "lodash";

// CONFIGURAÇÃO DE COSTUMIZAÇÃO

Vue.prototype.$usuario = new Vue({
    data() {
        return {
            // TODO: VARIAVEIS
            ENDPOINTS: ENDPOINTS,
            ID_LOGIN_SI: ID_LOGIN_SI,
            logins: [],
            win: [],
            modalEvento: {
                show: false,
                text: "",
            },
            access_token: false,
            menu: {
                show: false,
                loading: false,
            },
            cadastro: {
                nome: "",
                sobrenome: "",
                email: "",
                email2: "",
                senha: "",
                senha2: "",
                old_password: "",
                celular: "",
                celularComCodigoPais: "",
                cpf: "",
                passaporte: "",
                nacionalidade: "",
                dt_nascimento: "",
                dt_nascimento_temp: "",
                termos: false,
                loading: false,
                end_cep: "",
                end_pais: "",
                end_estado: "",
                end_cidade: "",
                end_bairro: "",
                end_numero: "",
                end_logradouro: "",
                error: {
                    nome: [],
                    sobrenome: [],
                    email: [],
                    email2: [],
                    old_password: [],
                    senha: [],
                    senha2: [],
                    nacionalidade: [],
                    dt_nascimento: [],
                    dt_nascimento_temp: [],
                    termos: [],
                    cpf: [],
                },
            },
            termoCompra: "",
            termosPendentes: null,
            dadosLoginPendente: null,
            modalAlertSucesso: false,
            logado: false,
            showModalLogin: false,
            showModalLoginEsqueciSenha: false,
            showModalLogin_cadastro: false,
            showModalLoginPersist: false,
        };
    },
    methods: {
        rotasEmails() {
            this.getloginSocialCadastro();
            this.confirmEmail();
            this.esqueceuSenha();
            this.openModalLogin();
        },

        openModalLogin() {
            let dados = {
                token: this.getSearchParams(
                    document.location.search,
                    "fazerlogin"
                ),
            };
            if (dados.token && !this.$axios.getLocal("session")) {
                this.$axios.setLocal("gorouter", "MeusPedidos");
                this.showModalLogin = true;
            }
        },

        confirmEmail() {
            let dados = {
                token: this.getSearchParams(
                    document.location.search,
                    "validatemail"
                ),
            };
            if (dados.token) {
                this.$axios.post(this.ENDPOINTS.CONFIRMAREMAIL, dados);
            }
        },

        esqueceuSenha() {
            let dados = {
                token: this.getSearchParams(
                    document.location.search,
                    "esqueceusenha"
                ),
            };
            if (dados.token) {
                const self = this;
                self.showModalLogin = true;
                setTimeout(() => {
                    self.showModalLoginEsqueciSenha = true;
                }, 800);
            }
        },

        getLogins() {
            // TODO: getLogins

            this.$axios
                .get(this.ENDPOINTS.GETLOGINS, false, false)
                .then((response) => {
                    let social = response.logins;
                    let logins = [];
                    social.forEach((item) => {
                        if (
                            item.tipo === "google" ||
                            item.tipo === "facebook"
                        ) {
                            logins.push(item);
                        }
                    });
                    this.logins = logins;
                })
                .catch(() => {
                    // console.log(error)
                });
        },

        getTermoCompra() {
            // TODO: getTermoCompra
            this.$axios
                .get(this.ENDPOINTS.GETTERMOCOMPRA, false, false)
                .then((response) => {
                    this.termoCompra = response;
                });
        },

        async getLogin(login) {
            // TODO: getLogin

            let recaptcha = "";

            if (this.$config.conf.recaptcha_ativo) {
                recaptcha = (await window.grecaptcha.getResponse()) || "";
                
                if (!recaptcha) {
                    await window.grecaptcha.execute();
                    return;
                }
            }

            login = Object.assign({}, login);
            let dados = {
                _username: login.email.trim(),
                _password: login.senha,
                _recaptcha: recaptcha,
            };

            if (login.termo) {
                dados._termo = true;
                this.$superingresso.aceiteTermo(login.email).then(() => {
                    this.fazerLogin(dados);
                });
                return;
            }
            this.fazerLogin(dados);
        },

        fazerLogin(dados) {
            this.dadosLoginPendente = dados;
            this.cadastro.loading = true;
            this.showModalLogin = false;

            this.$axios
                .post(this.ENDPOINTS.LOGIN + this.ID_LOGIN_SI, dados)
                .then((response) => {
                    if (this.$config.conf.recaptcha_ativo && window.grecaptcha) {
                        window.grecaptcha.reset();
                    }
                    if (response && response.access_token) {
                        this.$axios.setLocal("token", response.access_token);
                        this.$axios
                            .get(this.ENDPOINTS.DADOSCADASTRAIS)
                            .then((res) => {
                                let dados = res;
                                if (dados) {
                                    this.$axios.setLocal("session", dados);
                                    this.$axios.setLocal("confirm_login", true);
                                    this.logado = true;
                                    router.push({ name: "Home" });
                                    document.location.reload();
                                } else {
                                    if (location.pathname != "Home") {
                                        router.push({ name: "Home" });
                                    } else {
                                        window.scrollTo({
                                            top: 750,
                                            left: 0,
                                            behavior: "smooth",
                                        });
                                    }
                                }
                            });
                    }
                    this.cadastro.loading = false;
                })
                .catch(() => {
                    this.cadastro.loading = false;
                });
        },

        async aceitarTermosPendentes(idsTermos) {
            if (!this.termosPendentes || !this.dadosLoginPendente) return;

            const tiposTermo = new Map(
                this.termosPendentes.map((t) => [t.idtermo, t.idtipo_termo])
            );
            const aceite = await this.$axios.put(this.ENDPOINTS.UPDATETERMS, {
                username: this.dadosLoginPendente._username,
                terms: idsTermos.map((id) => ({
                    idtermo: id,
                    type_term: tiposTermo.get(id) || "",
                })),
            });
            if (aceite === false) return;

            this.termosPendentes = null;

            // O token do recaptcha já foi consumido na tentativa anterior, então o usuário precisa logar de novo
            if (this.$config.conf.recaptcha_ativo) {
                this.showModalLogin = true;
                return;
            }
            this.fazerLogin(this.dadosLoginPendente);
        },

        loginSocial(login, mobile) {
            // TODO: loginSocial
            this.menu.show = false;
            // CONFIGURAÇÕES DA JANELA

            const dualScreenLeft =
                window.screenLeft !== undefined
                    ? window.screenLeft
                    : screen.left;
            const dualScreenTop =
                window.screenTop !== undefined ? window.screenTop : screen.top;
            const width = window.innerWidth
                ? window.innerWidth
                : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
            const height = window.innerHeight
                ? window.innerHeight
                : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;
            const left = width / 2 - 500 / 2 + dualScreenLeft;
            const top = height / 2 - 400 / 2 + dualScreenTop;
            const settings =
                "height = 500, width = 600, top = " +
                top +
                ", left = " +
                left +
                ", scrollbars = true, resizable";

            if (mobile === true) {
                this.$axios.setLocal("mobile_social", true);
                document.location.href = login.url;
                return;
            }

            location.href = login.url;

            // this.win = window.open(login.url, login.tipo, settings);

            // const self = this;

            // let time = setInterval(() => {
            //     self.getSearchParamsModal('access_token');
            //     if(typeof self.access_token == 'string'){
            //         clearInterval(time);
            //     }
            // }, 200)
        },

        async recuperarSenha(email) {
            // TODO: recuperarSenha

            let recaptcha = "";

            if (this.$config.conf.recaptcha_ativo) {
                recaptcha = (await window.grecaptcha.getResponse()) || "";
            }

            if (this.$config.conf.recaptcha_ativo && recaptcha == "") {
                window.grecaptcha.execute();
                return;
            }

            this.menu.loading = true;

            let dados = {
                username: email,
                hashcaptcha: recaptcha,
            };

            this.$axios
                .post(this.ENDPOINTS.RECUPERARSENHA, dados)
                .then((response) => {
                    this.menu.loading = false;
                    this.menu.show = false;
                    if (this.$config.conf.recaptcha_ativo) {
                        window.grecaptcha.reset();
                    }
                    if (response && response.sucesso) {
                        {
                            this.$config.alert(response.msg_sucesso);
                            return;
                        }
                    }
                })
                .catch(() => {
                    this.menu.loading = false;
                    this.menu.show = false;
                    if (this.$config.conf.recaptcha_ativo) {
                        window.grecaptcha.reset(); 
                    }
                });
        },

        recoverySenha(dados) {
            // TODO: recoverySenha

            this.$axios
                .post(this.ENDPOINTS.RECUPERARSENHANOVASENHA, dados)
                .then((response) => {
                    if (response) {
                        router.push({ name: "Home" });
                    }
                });
        },

        async cadastrarPessoa() {
            // TODO: cadastrarPessoa

            let recaptcha = this.$config.conf.recaptcha_ativo
                ? await window.grecaptcha.getResponse()
                : null;

            const util_root = await new Util().getVue();

            if (recaptcha == "" && this.$config.conf.recaptcha_ativo) {
                await util_root.onCaptchaExpired(
                    document.getElementById("recaptcha-cadastro")
                );
                recaptcha = await window.grecaptcha.getResponse();
                return;
            }

            this.cadastro.loading = true;
            let dataNascimento = this.cadastro.dt_nascimento;

            // var datearray = dataNascimento.split('/')
            // var newdate = `${datearray[2]}-${datearray[1]}-${datearray[0]}`
            // dataNascimento = newdate;

            // let dados = {
            //     _nome         : this.cadastro.nome + ' ' + this.cadastro.sobrenome,
            //     _sobrenome    : '',
            //     _username     : this.cadastro.email.trim(),
            //     _password     : this.cadastro.senha,
            //     _nacionalidade: this.cadastro.nacionalidade,
            //     _idioma       : 'pt',
            //     _dt_nascimento: dataNascimento,
            //     _cpf          : this.cadastro.cpf,
            //     _passaporte   : this.passaporte,
            //     _celular      : this.cadastro.celularComCodigoPais,
            //     _recaptcha    : recaptcha,
            //     _newsletter   : false
            // }

            this.cadastro.email = this.cadastro.email.trim();
            this.cadastro.username = this.cadastro.email.trim();
            this.cadastro.dt_nascimento = dataNascimento;
            this.cadastro.celular = this.cadastro.celularComCodigoPais;
            this.cadastro.recaptcha = recaptcha;
            this.cadastro.password = this.cadastro.senha;

            this.cadastro.idioma = this.$axios.getLocal("lang")
                ? this.$axios.getLocal("lang").data.substring(0, 2)
                : "pt";
            let dados = {};
            Object.keys(this.cadastro).forEach((key) => {
                dados[`_${key}`] =
                    `${this.cadastro[key]}` == "null"
                        ? null
                        : `${this.cadastro[key]}`;
            });

            delete dados._error;
            try {
                this.$axios
                    .post(this.ENDPOINTS.CADASTROPESSOA, dados)
                    .then((response) => {
                        this.cadastro.loading = false;

                        if (response) {
                            this.$axios.setLocal("confirmCadastro", true);
                            if (this.$axios.getLocal("token")) {
                                router.push({ name: "Home" });
                                document.location.reload();
                            } else {
                                this.$config.alert(this.$t_("cadastro_concluido"));
                                this.showModalLogin_cadastro = false;
                            }
                        } else {
                            throw "Falha no cadastro";
                        }
                    })
                    .catch(async () => {
                        this.cadastro.loading = false;
                        //
                        if (this.$config.conf.recaptcha_ativo) {
                            await util_root.onCaptchaExpired(
                                document.getElementById("recaptcha-cadastro")
                            );
                        }
                    });
            } catch (error) {
                this.cadastro.loading = false;
                if (this.$config.conf.recaptcha_ativo) {
                    await util_root.onCaptchaExpired(
                        document.getElementById("recaptcha-cadastro")
                    );
                }
            }
        },

        async getPerfil() {
            // TODO: getPerfil
            return await this.$axios.get(this.ENDPOINTS.DADOSCADASTRAIS);
        },

        getSearchParamsModal(k) {
            // TODO: getSearchParamsModal
            const p = {};
            const self = this;
            if (!self.win.closed && self.win.location.search) {
                self.win.document.URL.replace(
                    /[?&]+([^=&]+)=([^&]*)/gi,
                    function (s, k, v) {
                        p[k] = v;
                        let saida = k ? p[k] : p;

                        if (self.win.name === "facebook") {
                            saida = saida.substring(0, saida.length - 4);
                        }

                        self.$axios.setLocal("token", saida);
                        self.$axios.setLocal("disabled", true);
                        self.win.close();
                        self.access_tokenSocial();
                    }
                );
            }

            self.access_token = false;
        },

        getSearchParams(win, k) {
            // TODO: getSearchParams
            const urlParams = new URLSearchParams(win);
            return urlParams.get(k);
        },

        async autoLogin() {
            // TODO: autoLogin
            const sleep = (segundos) => {
                return new Promise((resolve) =>
                    setTimeout(resolve, segundos * 1000)
                );
            };
            if (
                this.$axios.getLocal("token") &&
                (!this.$axios.getLocal("session") ||
                    (this.$axios.getLocal("session") &&
                        this.$axios.getLocal("session").data == true))
            ) {
                this.getPerfil().then((response) => {
                    if (response) {
                        this.$axios.setLocal("session", response);
                        if (this.$axios.getLocal("gorouter")) {
                            let rota = this.$axios.getLocal("gorouter").data;
                            this.$axios.remove("gorouter");
                            router.push({ name: rota });
                        }
                        //location.reload()
                    }
                });
            }

            await sleep(1);

            if (this.$axios.getLocal("session")) {
                let session = this.$axios.getLocal("session").data;

                if (
                    (session.idpessoa_tipo ==
                        this.$config.regrasDoNegocio.idagencia &&
                        !session.empresa_cnpj &&
                        !session.empresa_razao) ||
                    (session.idpessoa_tipo !=
                        this.$config.regrasDoNegocio.idagencia &&
                        ((!session.cpf && !session.passaporte) ||
                            (this.$config.dados.editarEndereco &&
                                !session.end_estado &&
                                !session.end_pais)))
                ) {
                    this.$config.alertWarn(this.$t_("preencha"));
                    this.$axios.rota("Perfil");
                }

                // RESERVA OS PRODUTOS NO CARRINHO ONLINE

                if (
                    this.$axios.getLocal("local_carrinho") &&
                    (session.cpf || session.passaporte) &&
                    session.end_estado &&
                    session.end_pais
                ) {
                    let local_carrinho =
                        this.$axios.getLocal("local_carrinho").data;
                    const self = this;

                    local_carrinho.forEach((item, index) => {
                        self.$carrinho.setCarrinhoLocal(item).then(() => {
                            // Atualizando carrinho após login
                            self.$carrinho.atualizaCarrinho();

                            self.$axios.remove("local_carrinho");
                            setTimeout(() => {
                                self.$axios.rota("Checkout");
                            }, 1000);
                        });
                    });
                }
            }
        },

        async getloginSocialCadastro() {
            // TODO: getloginSocialCadastro

            let link = document.location.search;

            if (link.indexOf("access_token") != -1) {
                let access_token = await this.getSearchParams(
                    document.location.search,
                    "access_token"
                );
                this.$axios.setLocal("token", access_token);
                this.getPerfil().then((response) => {
                    this.$axios.setLocal("session", response);
                    if (this.$axios.getLocal("gorouter")) {
                        let rota = this.$axios.getLocal("gorouter").data;
                        this.$axios.remove("gorouter");
                        router.push({ name: rota });
                    }
                });
            }

            return false;
        },

        async access_tokenSocial() {
            // TODO: access_tokenSocial

            if (
                !this.$axios.getLocal("token") ||
                this.$axios.getLocal("token").data.length == 0
            ) {
                return;
            }
            this.$axios.get(this.ENDPOINTS.DADOSCADASTRAIS).then((response) => {
                let dados = response;

                this.cadastro.nome = "";
                this.cadastro.sobrenome = "";
                this.cadastro.email = "";
                this.cadastro.email2 = "";

                if (dados != null && !dados.nacionalidade) {
                    this.cadastro.nome = this.getNome(dados.nome);
                    this.cadastro.sobrenome = this.getSobrenome(dados.nome);
                    this.cadastro.email = dados.email;
                    this.cadastro.email2 = dados.email;

                    this.showModalLogin_cadastro = true;
                }

                // CASO TENHA SENHA TEM QUE FAZER A LIGAÇÃO PARA IR PARA A TELA DE FASES
                if (dados && dados.nacionalidade) {
                    this.$axios.setLocal("session", dados);
                    this.$config.modalAlertSucesso = true;
                    this.$axios.setLocal("confirm_login", true);
                    this.logado = true;
                    // router.push({ name: 'JogosVenda' });
                    document.location.reload();
                }
            });
        },

        getNome(nome) {
            // TODO: getNome
            if (nome && nome.split(" ")) {
                return nome.split(" ")[0];
            }
            return nome;
        },

        getSobrenome(nome) {
            // TODO: getSobrenome
            if (nome && nome.split(" ")) {
                let sobrenome = "";
                nome = nome.split(" ");
                for (let i = 0; i < nome.length; i++) {
                    if (i > 0) {
                        sobrenome += nome[i] + " ";
                    }
                }
                return sobrenome;
            }
            return nome;
        },

        validarData(data) {
            // TODO: validarData

            if (this.$axios.getLocal("lang")) {
                this.$moment.locale(this.$axios.getLocal("lang").data);
            }

            if (
                this.$axios.getLocal("lang") &&
                this.$axios.getLocal("lang").data == "en-US"
            ) {
                data = data.split("/");
                data = `${data[2]}-${data[0]}-${data[1]}`;
            } else {
                data = data.split("/");
                data = `${data[2]}-${data[1]}-${data[0]}`;
            }

            let idade = this.$moment(data).fromNow();

            // if (this.$util.removerCaracteres(idade) > 18) {
            //     return true;
            // }

            return true;
        },

        getSexo() {
            // TODO: getSexo
            return [
                { dsc: this.$t_("nao_informado"), value: "1" },
                { dsc: this.$t_("masculino"), value: "2" },
                { dsc: this.$t_("feminino"), value: "3" },
            ];
        },

        removerCaracteres(v) {
            // TODO: removerCaracteres
            return v.toString().replace(/\D+/g, "");
        },
        async validarEmail(field) {
            // TODO: validarEmail
            // VERIFICA SE TEM O @ E O . ALÉM DO TAMANHO DO DOMINIO
            let usuario = field.substring(0, field.indexOf("@"));
            let dominio = field.substring(field.indexOf("@") + 1, field.length);

            if (
                usuario.length >= 1 &&
                dominio.length >= 3 &&
                usuario.search("@") == -1 &&
                dominio.search("@") == -1 &&
                usuario.search(" ") == -1 &&
                dominio.search(" ") == -1 &&
                dominio.search(".") != -1 &&
                dominio.indexOf(".") >= 1 &&
                dominio.lastIndexOf(".") < dominio.length - 1
            ) {
                return true;
            } else {
                return false;
            }
        },

        validarEmailSync(field) {
            // TODO: validarEmailSync
            // VERIFICA SE TEM O @ E O . ALÉM DO TAMANHO DO DOMINIO
            let usuario = field.substring(0, field.indexOf("@"));
            let dominio = field.substring(field.indexOf("@") + 1, field.length);

            if (
                usuario.length >= 1 &&
                dominio.length >= 3 &&
                usuario.search("@") == -1 &&
                dominio.search("@") == -1 &&
                usuario.search(" ") == -1 &&
                dominio.search(" ") == -1 &&
                dominio.search(".") != -1 &&
                dominio.indexOf(".") >= 1 &&
                dominio.lastIndexOf(".") < dominio.length - 1
            ) {
                return true;
            } else {
                return false;
            }
        },

        validaSenha(v) {
            // TODO: validaSenha
            // 1 caracterer maiusculo;
            // 1 caracterer minusculo;
            // 1 simbolo;
            // 1 numero;
            // 6 caracteres no minimo;

            let nivel = 0;
            let caracteres = v.toString().length;
            let car = "";

            let temMinusculo = false;
            let temMaiusculo = false;
            let temCaractere = false;
            let temNumero = false;
            let temLength = false;

            for (let index = 0; index < caracteres; index++) {
                car = v.charAt(index);

                // TESTA SE TEM NUMERO
                if (!isNaN(car * 1) && !temNumero) {
                    temNumero = true;
                    nivel += 1;
                }
                // TESTA SE É MAIUSCULO, MINUSCULO E SE TEM MAIS DE 6 CARACTERES
                else {
                    if (
                        /^[a-zA-Z0-9]+$/.test(car) &&
                        isNaN(car) &&
                        caracteres > 6 &&
                        !temLength
                    ) {
                        temLength = true;
                        nivel += 1;
                    }

                    if (
                        /^[a-zA-Z0-9]+$/.test(car) &&
                        isNaN(car) &&
                        car === car.toUpperCase() &&
                        !temMaiusculo
                    ) {
                        temMaiusculo = true;
                        nivel += 1;
                    }

                    if (
                        /^[a-zA-Z0-9]+$/.test(car) &&
                        isNaN(car) &&
                        car === car.toLowerCase() &&
                        !temMinusculo
                    ) {
                        temMinusculo = true;
                        nivel += 1;
                    }

                    // TESTA SE TEM CARACTERE
                    if (!temCaractere) {
                        if (!/^[a-zA-Z0-9]+$/.test(car)) {
                            temCaractere = true;
                            nivel += 1;
                        }
                    }
                }
            }

            return nivel * 2 * 10;
        },

        scrollCadastro() {
            // TODO: scrollCadastro
            window.scrollTo({
                top: 720,
                left: 0,
                behavior: "smooth",
            });
        },

        async trocarSenha() {
            // TODO: trocarSenha
            if (this.cadastro.old_password.length == 0) {
                this.$config.alertWarn(this.$t_("senha_atual"));
                this.$usuario.cadastro.error.old_password =
                    this.$t_("senha_atual");
                return;
            }
            if (this.validaSenha(this.cadastro.senha) < 60) {
                this.$config.alertWarn(this.$t_("preencha_senha_corret"));
                this.$usuario.cadastro.error.senha = this.$t_(
                    "preencha_senha_corret"
                );
                return;
            }
            if (this.cadastro.senha != this.cadastro.senha2) {
                this.$config.alertWarn(this.$t_("senhas_incompativeis"));
                this.$usuario.cadastro.error.senha2 = this.$t_(
                    "senhas_incompativeis"
                );
                return;
            }
            this.$axios
                .post(this.ENDPOINTS.TROCARSENHA, {
                    oldpassword: this.cadastro.old_password,
                    password: this.cadastro.senha,
                })
                .then((response) => {
                    if (response) {
                        sessionStorage.removeItem("token");
                        localStorage.removeItem("token");
                        this.$axios.destroy(true);
                    }
                });
        },

        async validarCadastro() {
            // TODO: validarCadastro
            const cadastro = Object.assign({}, this.cadastro);
            if (cadastro.nome.length < 2 || cadastro.nome == "") {
                this.$config.alertWarn(this.$t_("preencha_nome_corret"));
                this.$usuario.cadastro.error.nome = this.$t_(
                    "preencha_nome_corret"
                );
                this.scrollCadastro();
                return;
            }

            if (!this.validarData(cadastro.dt_nascimento)) {
                this.$config.alertWarn(this.$t_("idade_error"));
                this.$usuario.cadastro.error.dt_nascimento =
                    this.$t_("idade_error");
                this.scrollCadastro();
                return;
            }

            if (
                cadastro.email.length < 2 ||
                cadastro.email == "" ||
                (await !this.validarEmail(cadastro.email))
            ) {
                this.$config.alertWarn(this.$t_("preencha_email_corret"));
                this.$usuario.cadastro.error.email = this.$t_(
                    "preencha_email_corret"
                );
                this.scrollCadastro();
                return;
            }
            if (cadastro.email !== cadastro.email2) {
                this.$config.alertWarn(this.$t_("emails_incompativeis"));
                this.$usuario.cadastro.error.email2 = this.$t_(
                    "emails_incompativeis"
                );
                this.scrollCadastro();
                return;
            }

            if (!this.$superingresso.validarEmail(cadastro.email)) {
                this.scrollCadastro();
                return;
            }

            if (!this.$axios.getLocal("token")) {
                if (this.validaSenha(cadastro.senha) < 60) {
                    this.$config.alertWarn(this.$t_("preencha_senha_corret"));
                    this.$usuario.cadastro.error.senha = this.$t_(
                        "preencha_senha_corret"
                    );
                    this.scrollCadastro();
                    return;
                }
                if (cadastro.senha != cadastro.senha2) {
                    this.$config.alertWarn(this.$t_("senhas_incompativeis"));
                    this.$usuario.cadastro.error.senha2 = this.$t_(
                        "senhas_incompativeis"
                    );
                    this.scrollCadastro();
                    return;
                }
            }

            if (!cadastro.cpf && !cadastro.passaporte) {
                this.$config.alertWarn(this.$t_("preencha_doc_corret"));

                return;
            }
            if (
                !cadastro.celularComCodigoPais ||
                cadastro.celularComCodigoPais.length < 10 ||
                cadastro.celularComCodigoPais == ""
            ) {
                this.$config.alertWarn(this.$t_("preencha_cel_corret"));

                return;
            }

            if (this.$config.dados.editarEndereco) {
                if (
                    !cadastro.end_cep ||
                    cadastro.end_cep.length < 3 ||
                    cadastro.end_cep == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_cep"));
                    return;
                }
                if (
                    !cadastro.end_pais ||
                    cadastro.end_pais.length < 2 ||
                    cadastro.end_pais == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_pais_corret"));
                    return;
                }
                if (
                    !cadastro.end_cidade ||
                    cadastro.end_cidade.length < 2 ||
                    cadastro.end_cidade == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_cidade_corret"));
                    return;
                }
                if (!cadastro.end_estado || cadastro.end_estado == "") {
                    this.$config.alertWarn(this.$t_("preencha_estado_corret"));
                    return;
                }
                if (
                    !cadastro.end_logradouro ||
                    cadastro.end_logradouro.length < 2 ||
                    cadastro.end_logradouro == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_end_corret"));
                    return;
                }
            }

            if (cadastro.termos == false) {
                this.$config.alertWarn(this.$t_("deve_aceitar"));
                this.$usuario.cadastro.error.termos = this.$t_("deve_aceitar");
                return;
            }

            let recaptcha = this.$config.conf.recaptcha_ativo
                ? await window.grecaptcha.getResponse()
                : null;

            if (recaptcha == "" && this.$config.conf.recaptcha_ativo) {
                const util_root = await new Util().getVue();
                await util_root.onCaptchaExpired(
                    document.getElementById("recaptcha-cadastro")
                );
                if (recaptcha == "") {
                    this.$config.alertWarn(this.$t_("recaptcha_invalido"));
                }
                return;
            }

            if (this.$axios.getLocal("token")) {
                cadastro.senha = "";
                cadastro.senha2 = "";
                this.setEditLoginSocial();
                return;
            }

            this.cadastrarPessoa();
        },

        onchangerEmail() {
            // TODO: onchangerEmail
            this.$axios
                .post(this.ENDPOINTS.VALIDAREMAIL, {
                    email: this.cadastro.email,
                })
                .then((response) => {
                    if (!response) {
                        this.$usuario.cadastro.error.email =
                            this.$t_("email_cadastrado");
                    }
                });
        },

        async onchangerData() {
            // TODO: onchangerData
            setTimeout(async () => {
                if (this.cadastro.dt_nascimento.length > 0) {
                    if (await this.validarData(this.cadastro.dt_nascimento)) {
                        this.$usuario.cadastro.error.dt_nascimento =
                            this.$t_("idade_error");
                        return;
                    }
                }
            }, 750);
        },

        setEditLoginSocial() {
            // TODO: setEditLoginSocial
            let dados = this.cadastro;
            let dataNascimento = dados.dt_nascimento;

            if (this.$axios.getLocal("lang").data == "en-US") {
                var datearray = dataNascimento.split("/");
                var newdate = `${datearray[2]}-${datearray[0]}-${datearray[1]}`;
                dataNascimento = newdate;
            } else {
                var datearray = dataNascimento.split("/");
                var newdate = `${datearray[2]}-${datearray[1]}-${datearray[0]}`;
                dataNascimento = newdate;
            }

            dados.nome = this.cadastro.nome + " " + this.cadastro.sobrenome;

            this.$axios
                .post(this.ENDPOINTS.DADOSCADASTRAIS, dados)
                .then((response) => {
                    if (response) {
                        this.$axios.setLocal("confirmEdit", true);
                        let dados = response;
                        if (dados.nacionalidade != "") {
                            this.$axios.setLocal("session", dados);
                            router.push({ name: "JogosVenda" });
                            document.location.reload();
                        } else {
                            if (
                                location.pathname != "/pt/intencaodecompra" ||
                                location.pathname != "/es/intenciondecompra" ||
                                location.pathname != "/en/buy-intention"
                            ) {
                                router.push({ name: "JogosVenda" });
                                window.scrollTo({
                                    top: 750,
                                    left: 0,
                                    behavior: "smooth",
                                });
                            } else {
                                window.scrollTo({
                                    top: 750,
                                    left: 0,
                                    behavior: "smooth",
                                });
                            }
                        }
                    }
                });
        },

        setEdit(dados) {
            // TODO: setEdit
            let temp = Object.assign({}, dados);

            if (this.$config.dados.editarEndereco) {
                if (
                    !temp.end_cep ||
                    temp.end_cep.length < 3 ||
                    temp.end_cep == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_cep"));
                    return;
                }
                if (
                    !temp.end_pais ||
                    temp.end_pais.length < 2 ||
                    temp.end_pais == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_pais_corret"));
                    return;
                }
                if (
                    !temp.end_cidade ||
                    temp.end_cidade.length < 2 ||
                    temp.end_cidade == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_cidade_corret"));
                    return;
                }
                if (!temp.end_estado || temp.end_estado == "") {
                    this.$config.alertWarn(this.$t_("preencha_estado_corret"));
                    return;
                }
                if (
                    !temp.end_logradouro ||
                    temp.end_logradouro.length < 2 ||
                    temp.end_logradouro == ""
                ) {
                    this.$config.alertWarn(this.$t_("preencha_end_corret"));
                    return;
                }
            }

            if (!temp.termos) {
                this.$config.alertWarn(this.$t_("deve_aceitar"));
                return;
            }

            let data = temp.dt_nascimento;

            if (
                this.$axios.getLocal("lang") &&
                this.$axios.getLocal("lang").data == "en-US"
            ) {
                data = data.split("/");
                data = `${data[2]}-${data[0]}-${data[1]}`;
            } else {
                data = data.split("/");
                data = `${data[2]}-${data[1]}-${data[0]}`;
            }

            temp.dt_nascimento = data;

            temp.celular = temp.celularComCodigoPais;

            this.$axios
                .post(this.ENDPOINTS.DADOSCADASTRAIS, temp)
                .then((response) => {
                    this.$axios.setLocal("session", temp);
                    if (response) {
                        this.$axios.setLocal("confirmEdit", true);
                        this.$config.alert(this.$t_("alterado"));
                        setTimeout(() => {
                            document.location.href = "/";
                        }, 1000);
                    }
                });
        },
    },
});

Vue.prototype.$usuario.getLogins();

// Vue.prototype.$usuario.validarData('30/12/1987')
